import { reactive } from "@vue/composition-api";

const global = reactive({
  totalPortals: -1,
  totalGroups: -1,
  totalNas: -1,
  appTabs: [],
  selectedAppTab: 0,
  tabsDisabled: false,
});

export default global;
